import { render, staticRenderFns } from "./AccountTwoFaStepDownload.vue?vue&type=template&id=4405cc39&scoped=true"
import script from "./AccountTwoFaStepDownload.vue?vue&type=script&lang=js"
export * from "./AccountTwoFaStepDownload.vue?vue&type=script&lang=js"
import style0 from "./AccountTwoFaStepDownload.vue?vue&type=style&index=0&id=4405cc39&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4405cc39",
  null
  
)

export default component.exports